import { render, staticRenderFns } from "./direct_message_dialog.vue?vue&type=template&id=6b175ed3"
import script from "./direct_message_dialog.vue?vue&type=script&lang=ts"
export * from "./direct_message_dialog.vue?vue&type=script&lang=ts"
import style0 from "./direct_message_dialog.vue?vue&type=style&index=0&id=6b175ed3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports